if (!customElements.get('loyalty-points-pdp')) {
    // Shared by every loyalty widget on the page: one API call per SKU/price, reused on repeat switches (avoids 429s)
    const loyaltyPointsRequests = {};

    customElements.define('loyalty-points-pdp', class LoyaltyPointsPdp extends HTMLElement {
      constructor() {
        super();
      }
  
      // disconnectedCallback() {
      //   document.removeEventListener("theme:cart:change", () => {
      //     this.updateLoyaltyPoints();
      //   });
      // }
  
      connectedCallback() {
        console.log('Loyalty points PDP connected');
       // this.updateLoyaltyPoints();

       this.fetchCustomerPoints(this.getAttribute('data-sku'), 1, parseFloat(this.getAttribute('data-price')));

       document.addEventListener("theme:variant:change", (event) => {
        //this.updateLoyaltyPoints();
        console.log('Variant changed', event.detail.variant);
        const variant = event.detail && event.detail.variant;
        if (!variant || !variant.sku) return;
        // Wait for scent/size switching to settle so only the final variant hits the API
        clearTimeout(this.variantChangeTimer);
        this.variantChangeTimer = setTimeout(() => {
          this.fetchCustomerPoints(variant.sku, 1, variant.price);
        }, 300);
      });

      }

      async fetchCustomerPoints(sku, quantity, price) {
        if (!sku) {
          console.warn("Missing SKU for loyalty points request.");
          return;
        }

        // Track the latest request so a slower response for a previous scent can't overwrite it
        const requestId = (this.requestId = (this.requestId || 0) + 1);

        try {
          // Prepare the payload for the API request
          const payload = {
            cartItems: [
              {
                sku: sku,
                quantity: quantity || 1,
                price: price ? price / 100 : 0,
              },
            ],
            state: "open",
          };
    
          // Loyalty Points API URL
          let url = `https://azsu-rg-integration-qa-func-talon.azurewebsites.net/api/loyalty/points/product?code=P2lX5NUxGMJK-pI4oX2MhDF9kVYZkv1dB4TxRSvwXqfJAzFuNKvuVQ==`;
          if(Shopify.shop === 'the-body-shop-uk.myshopify.com') {
            url = `https://azsu-integration-prod-apim-ecomm.azure-api.net/azsu-integration-prod-func-talonOne/loyalty/points/product`;
          }
          // Perform the API request (or reuse one already made for this SKU/price)
          const cacheKey = `${sku}|${payload.cartItems[0].price}`;
          if (!loyaltyPointsRequests[cacheKey]) {
            const sendRequest = () => fetch(url, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
              },
              body: JSON.stringify(payload),
              redirect: "manual",
            });
            loyaltyPointsRequests[cacheKey] = sendRequest().then((response) => {
              // Rate limited: retry once after a short pause
              if (response.status === 429) {
                return new Promise((resolve) => setTimeout(resolve, 1500)).then(sendRequest);
              }
              return response;
            }).then((response) => {
              // Check if the response is successful
              if (response.status !== 200) throw new Error("API responded with an error.");
              return response.json();
            }).catch((error) => {
              // Don't keep failed requests so the next switch can retry
              delete loyaltyPointsRequests[cacheKey];
              throw error;
            });
          }

          // Parse the response JSON
          const responseJSON = await loyaltyPointsRequests[cacheKey];
          const points = responseJSON.points || 0; // Default to 0 points if none is returned
          if (requestId !== this.requestId) return;

            // Update the points display for all users
            const loyaltyText = this.querySelector('[data-text]');
            if(!!loyaltyText){
              const text = loyaltyText.dataset.text.replace("__points__", points);
              loyaltyText.innerText = text;
            }
          const valueContainer = this.querySelectorAll(".loyalty-points__value-product");
          valueContainer.forEach((container) => {
            container.innerText = `${points}`;
          });
        } catch (error) {
          console.error("Error fetching loyalty points:", error);
        }
      }
    });
}
